import { RootState } from '@core/Store'

export const getSkyRaceFilters = ({ skyRaces }: RootState) => skyRaces.filters
export const getResetTimestamp = ({ skyRaces }: RootState) => skyRaces.resetTimestamp
export const getIsSkyRaceListViewOpen = ({ skyRaces }: RootState) => skyRaces.isSkyRaceListViewOpen
export const getSkyRaceLimit = ({ skyRaces }: RootState) => skyRaces.skyRaceLimit
export const getIsSelectedRaceScrolledOutOfView = ({ skyRaces }: RootState) =>
  skyRaces.isSelectedRaceScrolledOutOfView
